import React, { useEffect, useState, useRef } from "react";
import axios from "axios";
import katex from "katex";
import "katex/dist/katex.min.css";
const EditableOptions = () => {
  const [questions, setQuestions] = useState([]);
  const [editedQuestions, setEditedQuestions] = useState([]);
  const optionRefs = useRef({});

  // Fetch questions from API
  useEffect(() => {
    const fetchQuestions = async () => {
      try {
        const response = await axios.get(
          "https://dev.dse-cc-api.com/coaching-collaborator-api/api/v1/get-parsed-questions-for-initial-review/?client_id=1&client_branch_id=1&parse_ques_set_id=1353",
          {
            headers: {
              accept: "application/json",
              Authorization:
                "Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiJzaWRkaGFydGgiLCJleHAiOjE3MzQ3MDIwMTF9.hhEbJkJb_GSG52kEgzqVUSotegdf869jNtPH_Ip4Uuk",
            },
          }
        );
        setQuestions(response.data);
        setEditedQuestions(response.data);
      } catch (error) {
        console.error("Error fetching questions:", error);
      }
    };

    fetchQuestions();
  }, []);

  // Handle option editing
  const handleOptionEdit = (questionId, optionNo, value) => {
    setEditedQuestions((prev) =>
      prev.map((question) =>
        question.question_id === questionId
          ? {
              ...question,
              options: question.options.map((option) =>
                option.option_no === optionNo
                  ? { ...option, option_text: value }
                  : option
              ),
            }
          : question
      )
    );
  };

  const processText = (text) => {
    // Replace imgsrc with <img> tags
    text = text.replace(
      /imgsrc=([^ ]+)/g,
      '<img src="$1" class="Img-RQ-QnsAns" alt="image" />'
    );

    // Render LaTeX expressions
    const latexRegex = /\\\((.*?)\\\)/g;
    text = text.replace(latexRegex, (match, p1) => {
      return katex.renderToString(p1, { throwOnError: false });
    });

    return text;
  };
  // Function to calculate progress
  const calculateProgress = (question) => {
    const totalOptions = question.options.length;
    const correctOptions = question.options.filter(
      (option) => option.option_correct_flag === 1
    ).length;
    return `${correctOptions} out of ${totalOptions} options are correct`;
  };
  return (
    <div style={{ display: "flex", gap: "20px" }}>
      {/* Left Side - Editable Options */}
      <div style={{ width: "50%", overflowY: "auto" }}>
        <h1>Editable Options</h1>
        {editedQuestions.map((question) => (
          <div
            key={question.question_id}
            style={{
              border: "1px solid #ccc",
              padding: "10px",
              marginBottom: "20px",
            }}
          >
            <div>
              <strong>Options:</strong>
              {question.options.map((option) => (
                <div
                  key={option.option_no}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    marginBottom: "10px",
                  }}
                >
                  <div>
                    <input
                      type="checkbox"
                      checked={option.option_correct_flag === 1}
                      onChange={(e) =>
                        handleOptionEdit(
                          question.question_id,
                          option.option_no,
                          {
                            ...option,
                            option_correct_flag: e.target.checked ? 1 : 0,
                          }
                        )
                      }
                      style={{ marginRight: "10px" }}
                    />
                  </div>

                  <div
                    contentEditable
                    suppressContentEditableWarning
                    onInput={(e) => {
                      handleOptionEdit(
                        question.question_id,
                        option.option_no,
                        e.target.innerText
                      );
                    }}
                    style={{
                      border: "1px solid #ddd",
                      padding: "5px",
                      width: "100%",
                    }}
                  >
                    {option.option_text}
                  </div>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>

      {/* Right Side - Display Changes */}
      <div
        style={{
          width: "50%",
          overflowY: "auto",
          border: "1px solid #ccc",
          padding: "10px",
        }}
      >
        <h1>Updated Options</h1>
        {editedQuestions.map((question) => (
          <div
            key={question.question_id}
            style={{
              borderBottom: "1px solid #ddd",
              padding: "10px 0",
              marginBottom: "10px",
            }}
          >
            <div>
              <strong>Options:</strong>
              {question.options.map((option) => (
                <div key={option.option_no}>
                  <input
                    type="checkbox"
                    checked={option.option_correct_flag === 1}
                    readOnly
                  />
                  {option.option_text}
                </div>
              ))}
              <div>
                <strong>Progress:</strong> {calculateProgress(question)}
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default EditableOptions;
